import React, { useState, useEffect, useRef } from 'react';
import Button from '@material-ui/core/Button';
import Api from '../../../__helpers/api';
import { useAuthDataContext } from '../../../__providers/AuthProvider';
import Gallery from '../../modals/Gallery';

//style
import '../../../assets/css/qna.css';

//images
import replayIcon from '../../../assets/images/qna/replay-icon.png';
import pictureIcon from '../../../assets/images/qna/picture-icon.png';
import deletePicIcon from '../../../assets/images/qna/delete-pic.png';
import loader from '../../../assets/images/contacts/loader.svg';

function QnA(props) {
    const auth = useAuthDataContext();
    const galleryRef = useRef(null);

    const [comment, setComment] = useState({
        write: {},
        data: [],
        loading: false,
        imageName: '',
        imageUrl: '',
    })

    useEffect(() => {
        console.log(galleryRef)
        if (!props.topic_id && auth.user.is_student) return;
        let url;

        if (auth.user.is_student) {
            url = `student/topics/inquiries?topic_id=${props.topic_id}`;
        } else {
            url = `center/topics/inquiries?group_id=${props.currentGroup}`;
        }

        Api.get(url)
            .then(res => {
                setComment(comment => {
                    return {
                        ...comment,
                        data: res.data,

                    }
                })
            })
    }, [props.currentGroup, props.topic_id, props.update])

    const handleReplay = e => {
        let id = e.target.getAttribute('data-id');
        let write = comment.write;
        write[id] = true;

        setComment(comment => {
            return {
                ...comment,
                write: write,
            }
        })
    }

    const handleSend = () => {

    }

    const handleRemoveImage = () => {

    }


    const toggleComment = e => {
        if (!e.target.classList.contains('closed')) {
            return;
        }

        let listItems = document.getElementsByClassName('qna-li');
        for (var i = 0, all = listItems.length; i < all; i++) {
            listItems[i].classList.add('closed');
        }
        e.target.classList.remove('closed')
    }

    const handleComment = e => {
        setComment(comment => {
            return {
                ...comment,
                loading: true,

            }
        })
        e.preventDefault();
        let data = new FormData(e.target);

        // let studentId = e.target.querySelectorAll('[name=student_id]')[0].value;

        Api.post('center/topics/inquiries/answer', data)
            .then(res => {
                Api.get('center/topics/inquiries')
                    .then(res => {
                        setComment(comment => {
                            return {
                                ...comment,
                                data: res.data,
                                loading: false,
                                imageName: null,
                            }
                        })
                    });


                props.handleAddInquiryAnswer();
            })
            .catch(err => {
                setComment(comment => {
                    return {
                        ...comment,
                        loading: false,
                        imageName: null,
                    }
                })
            })
    }

    const handleImage = e => {
        if (e.target.files.length == 0) {
            setComment(comment => {
                return {
                    ...comment,
                    imageName: '',
                }
            })
            return;
        };
        let name = e.target.files[0].name;
        setComment(comment => {
            return {
                ...comment,
                imageName: name,
            }
        })
    }

    const handleViewImage = e => {
        let url = e.target.src
        galleryRef.current.show(url)
    }

    return (
        comment.data.length > 0 ?
            <section id="QnA">
                <Gallery 
                    url={comment.imageUrl}
                    ref={galleryRef}
                />
                {auth.user.is_student ?
                    <h2>
                        Моите въпроси
                    </h2>
                    :
                    <h2>
                        {window.location.pathname == '/' ?
                            'Последно зададени въпроси'
                            :
                            'Въпроси от моите курсисти'
                        }
                    </h2>
                }
                <ul>
                    {comment.data.map((each, i) =>
                        <li data-id={each.id} key={each.id} className={i == 0 ? 'qna-li' : 'closed qna-li'} onClick={toggleComment}>
                            <div className="head">
                                <picture>
                                    <img src={each.student.user.avatar} alt="profile" />
                                </picture>
                                <h3>
                                    {each.student.user.name}  {each.student.user.lastname}
                                </h3>
                                <p>
                                    Въпрос от <span>тема {each.topic.parent.position}.{each.topic.position}</span>
                                </p>
                            </div>
                            <div className="body">
                                <p className="comment-text">
                                    {each.text}
                                </p>
                                {each.answered != 1 ?
                                    !auth.user.is_student && comment.write[each.id] == true ?
                                        <>
                                            <form onSubmit={handleComment}>
                                                <input type="hidden" value={each.id} name="id" />
                                                <input type="hidden" value={each.student.id} name="student_id" />
                                                <div className="comment-area-wrapper">
                                                    <textarea name="text" placeholder="Напишете Вашият отговор.."></textarea>
                                                    <div className="file">
                                                        <h4>
                                                            <img src={pictureIcon} alt="picture" />
                                                            <input name="image" onChange={handleImage} accept="image/*" type="file" />
                                                    Прикачете снимка
                                                    </h4>
                                                        <p>
                                                            {comment.imageName ? comment.imageName : ''}

                                                        </p>
                                                    </div>
                                                </div>
                                                {comment.loading ?
                                                    <img src={loader} alt="loader" className="loader" />
                                                    :
                                                    <Button type="submit" onClick={handleSend} className="send">
                                                        Изпращане
                                                </Button>
                                                }
                                            </form>
                                        </>
                                        :
                                        !auth.user.is_student ?
                                            <Button data-id={each.id} onClick={handleReplay}>
                                                Отговор
                                        <img src={replayIcon} alt="replay" />
                                            </Button>
                                            :
                                            ''
                                    :
                                    each.answers.map(answer =>
                                        <div className="comment">
                                            <div className="head">
                                                <picture>
                                                    <img src={answer.author.avatar} alt="avatar" />
                                                </picture>
                                                <div className="right">
                                                    <h3>
                                                        {answer.author.name}  {answer.author.lastname}
                                                    </h3>
                                                    <p>
                                                        Инструктор в автошкола {answer.author.center.public_name}
                                                    </p>
                                                </div>
                                            </div>
                                            <div className="body">
                                                <p>
                                                    {answer.text}
                                                    {answer.picture ?
                                                        <img src={answer.picture} alt="image" onClick={handleViewImage} />
                                                        :
                                                        ''
                                                    }
                                                </p>
                                            </div>
                                        </div>
                                    )
                                }
                            </div>
                        </li>
                    )}
                </ul>
            </section>
            :
            ''
    )
}

export default QnA;